import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-12 px-4 flex items-center justify-center">
      <div className="prose dark:prose-invert max-w-4xl w-full p-8 sm:p-12 bg-white/80 dark:bg-dark-surface/80 backdrop-blur-md rounded-[3rem] border border-light-gray/20 dark:border-dark-border/20 shadow-float-lg">
        <h1 className="text-4xl font-black text-charcoal dark:text-white mb-8 tracking-tight">Privacy Policy</h1>
        <p className="text-muted-gray font-bold uppercase tracking-widest text-xs mb-8">Last updated: February 15, 2026</p>

        <section className="space-y-6 text-charcoal dark:text-gray-300">
          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">1. Introduction</h2>
            <p>Your privacy is important to us. This Privacy Policy explains how Safzi ("Platform") collects, uses, and protects your personal information when you use our services.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">2. Information We Collect</h2>
            <p>We collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Personal Identification Information:</strong> Your email address and phone number for account creation and verification.</li>
              <li><strong>Deriv Account Information:</strong> We securely store your Deriv Account ID, Account Name, and Account Type (Agent/Client) via an OAuth connection. We do not request or store trading permissions.</li>
              <li><strong>Transaction Data:</strong> We maintain a log of all transaction activities, including timestamps, amounts, and user IDs, to provide a complete history and for reporting purposes.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">3. How We Use Your Information</h2>
            <p>Your information is used to provide, operate, and maintain our Platform, authenticate your identity, and facilitate secure funding transactions between users.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">4. Information Sharing</h2>
            <p>We do not sell or trade your personally identifiable information. Your Deriv account name is shared with the counterparty in a transaction solely for payment verification.</p>
          </div>

          <div>
            <h2 className="text-2xl font-black text-charcoal dark:text-white mb-3">5. Data Security</h2>
            <p>We implement a variety of security measures to maintain the safety of your personal information. All communication with our Platform is encrypted, and sensitive data is stored securely.</p>
          </div>
        </section>
        
        <div className="mt-12 pt-8 border-t border-light-gray/20">
          <button onClick={() => navigate(-1)} className="text-soft-green font-black hover:text-light-mint transition-colors bg-transparent border-none cursor-pointer flex items-center gap-2">
            &larr; Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;